import React from 'react';
import PropTypes from 'prop-types';

const CalendarCheckYellowCircleIcon = ({ iconClasses }) => (
    <svg
        className={iconClasses}
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="20.1635" cy="20" r="20" fill="#FAD536" />
        <g clipPath="url(#clip0)">
            <path
                d="M27.6635 20.5V15.5C27.6635 14.948 27.2155 14.5 26.6635 14.5H13.6635C13.1115 14.5 12.6635 14.948 12.6635 15.5V26.5C12.6635 27.052 13.1115 27.5 13.6635 27.5H19.6635"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.6635 17.5H27.6635"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.6635 12.5V14.5"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.6635 12.5V14.5"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.6635 25.5L23.6635 27.5L27.6635 23.5"
                stroke="black"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(12.1635 12)"
                />
            </clipPath>
        </defs>
    </svg>
);

CalendarCheckYellowCircleIcon.propTypes = {
    iconClasses: PropTypes.string,
};

export default CalendarCheckYellowCircleIcon;
